<div class="container-fluid" id="manageCustomQuestionnaire">
    <div class="row">
        <div class="col-12">    
            <p-tabView [(activeIndex)]="index" (onChange)="handleChange($event)">
                <p-tabPanel header="Request Data" [headerStyle]='{"width": "250px"}'>
                    <div class="mt-4">
                        <app-request-data-documents [beneficiaryData]="beneficiaryDetails"></app-request-data-documents>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Data Log" [headerStyle]='{"width": "250px"}'>
                    <div class="mt-4">                        
                        <app-data-log #dataLogComponent></app-data-log>
                    </div>
                </p-tabPanel>              
            </p-tabView>
        </div>
    </div>
</div>
